import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';

import { AuthService } from 'src/app/core/services/auth-service/auth.service';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RedirectHelperService } from 'src/app/shared/services/redirect-helper/redirect-helper-service';
import { StageConfigService } from '../../services/stage-config/stage-config.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private readonly authService = inject(AuthService);
  private readonly redirectHelper = inject(RedirectHelperService);
  private readonly stageConfigService = inject(StageConfigService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return new Observable<HttpEvent<any>>((subscriber) => {
      next.handle(req).subscribe(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            subscriber.next(event);
            subscriber.complete();
          }
        },

        (error) => {
          if (
            error instanceof HttpErrorResponse &&
            error.status === 401 &&
            req.url.indexOf(this.stageConfigService.config.paymentsApiUrl) === -1 &&
            !this.authService.isRefreshTokenUrl(req.url)
          ) {
            this.logInfo(`Detected 401 for the ${req.method} request on ${req.url}`);

            this.authService.refreshToken().subscribe(
              (user) => {
                const newRequest = req.clone({
                  setHeaders: {
                    Authorization: `Bearer ${user.access_token}`,
                  },
                });

                this.logInfo(`Successfully refreshed token for the ${req.method} request on ${req.url}`);

                next.handle(newRequest).subscribe(
                  (newEvent) => {
                    if (newEvent instanceof HttpResponse) {
                      subscriber.next(newEvent);

                      this.logInfo(`Successfully retried the ${req.method} request on ${req.url}`);

                      subscriber.complete();
                    }
                  },
                  (innerError) => {
                    this.logError(
                      `An error occured while retrying the ${req.method} request on ${req.url}`,
                      innerError.message,
                      innerError,
                    );

                    subscriber.error(innerError);
                  },
                );
              },
              (refreshError) => {
                this.logError(
                  `An error occured while refreshing token for the ${req.method} request on ${req.url}`,
                  refreshError.message,
                  refreshError,
                );

                this.redirectHelper.redirectToLoginPage();
                subscriber.error(refreshError);
              },
            );
          } else {
            subscriber.error(error);
          }
        },
      );
    });
  }

  // TODO - Hybrid App - replace with a global Logger service
  private logInfo(...messages: any[]): void {
    // eslint-disable-next-line no-console
    console.log('ErrorInterceptor', ...messages);
  }

  private logError(...messages: any[]): void {
    // eslint-disable-next-line no-console
    console.error('ErrorInterceptor', ...messages);
  }
}
